import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Slider from 'react-slick';
import _debounce from 'lodash/debounce';
import {
	Container,
	Col,
	Row,
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	FormGroup,
	Input,
	Label,
} from 'reactstrap';

import logo1 from '../../assets/images/rhodes_0000_insight.jpg';
// import logo2 from '../../assets/images/rhodes_0001_dixons.jpg';
import logo3 from '../../assets/images/rhodes_0002_booker.jpg';
import logo4 from '../../assets/images/rhodes_0003_mercedes.jpg';
import logo5 from '../../assets/images/rhodes_0004_ceva.jpg';
import logo6 from '../../assets/images/rhodes_0005_johnlewis.jpg';
// import logo7 from '../../assets/images/rhodes_0006_wpcarey.jpg';
import logo8 from '../../assets/images/rhodes_0007_menzies.jpg';
// import logo9 from '../../assets/images/rhodes_0008_nhs.jpg';
import logo10 from '../../assets/images/rhodes_0009_torquelogistics.jpg';
import logo11 from '../../assets/images/rhodes_0010_wakefieldcouncil.jpg';
import logo12 from '../../assets/images/rhodes_0011_ironmountain.jpg';
// import logo13 from '../../assets/images/rhodes_0012_langtree.jpg';
// import logo14 from '../../assets/images/rhodes_0013_gladman.jpg';
// import logo15 from '../../assets/images/rhodes_0014_haworthestates.jpg';
import logo16 from '../../assets/images/rhodes_0015_astonbarclay.jpg';
// import logo17 from '../../assets/images/rhodes_0016_shopdirect.jpg';
// import logo18 from '../../assets/images/rhodes_0017_sjs.jpg';
// import logo19 from '../../assets/images/rhodes_0018_rpm.jpg';
import logo20 from '../../assets/images/rhodes_0019_usl.jpg';
import logo21 from '../../assets/images/rhodes_0020_morrells.jpg';
import logo22 from '../../assets/images/rhodes_0021_tor.jpg';
import logo23 from '../../assets/images/rhodes_0022_yodel.jpg';
import logo24 from '../../assets/images/rhodes_0023_lidl.jpg';
import logo25 from '../../assets/images/rhodes_0024_ocado.jpg';
import logo26 from '../../assets/images/rhodes_0025_coop.jpg';
import logo27 from '../../assets/images/rhodes_0026_thepeelgroup.jpg';
import logo28 from '../../assets/images/rhodes_0027_kimberleyclark.jpg';
// import logo29 from '../../assets/images/rhodes_0028_dunlop.jpg';
import logo30 from '../../assets/images/rhodes_0029_goodyear.jpg';
import logo31 from '../../assets/images/rhodes_0030_standardlife.jpg';
import logo32 from '../../assets/images/rhodes_0031_Asda.jpg';
import logo33 from '../../assets/images/rhodes_0033_superbike.jpg';
import logo34 from '../../assets/images/rhodes_0034_tremo.jpg';
import logo36 from '../../assets/images/rhodes_0036_rust.jpg';
import rics from '../../assets/images/rics2.png';
import tor from '../../assets/images/torcoatings.jpg';

import logo from '../../assets/images/rhodes-logo.png';
import logoSmall from '../../assets/images/logo-small.png';
import building from '../../assets/images/building-1.jpg';

// import case1 from '../../assets/images/case-1.jpg';
// import case2 from '../../assets/images/case-2.jpg';
import case4 from '../../assets/images/case-4.jpg';
// import case5 from '../../assets/images/case-5.jpg';


// class ScrollButton extends React.Component {
// 	constructor() {
// 		super();

// 		this.state = {
// 			intervalId: 0
// 		};
// 	}

// 	scrollStep() {
// 		console.log(window.pageYOffset)
// 		if (window.pageYOffset === 0) {
// 			clearInterval(this.state.intervalId);
// 		}
// 		window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
// 	}

// 	scrollToTop() {
// 		let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
// 		this.setState({ intervalId: intervalId });
// 	}

// 	render() {
// 		return <button title='Back to top' className='scroll'
// 			onClick={() => { this.scrollToTop(); }}>
// 			<span className='arrow-up glyphicon glyphicon-chevron-up'></span>
// 		</button>;
// 	}
// }

import { caseStudies } from '../../assets/json/casestudies';



export default class RhodesCRE extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cvData: this.props.data,
			navbarStatus: 'fixed',
			fullName: '',
			email: '',
			phone: '',
			message: '',
			open: false,
			modalContent: null
		};
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleFullNameChange = this.handleFullNameChange.bind(this);
		this.handleMessageChange = this.handleMessageChange.bind(this);
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		this.handleScroll = _debounce(this.handleScroll.bind(this), 1);
	}

  onOpenModal = (caseStudy) => {
    this.setState({ open: true, modalContent: caseStudy });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll, true);
		const script = document.createElement("script");

		script.src = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
		script.async = true;

		document.body.appendChild(script);
	}

	componentWillUnmount() {
		// If this component is unmounted, stop listening
		window.removeEventListener('scroll', this.handleScroll, false);
	}

	handleEmailChange(evt) {
		this.setState({ email: evt.target.value });
	}

	handleFullNameChange(evt) {
		this.setState({ fullName: evt.target.value });
	}

	handleMessageChange(evt) {
		this.setState({ message: evt.target.value });
	}

	handlePhoneChange(evt) {
		this.setState({ phone: evt.target.value });
	}

	handleScroll(event) {
		const scrollTop = event.target.scrollTop;
		if (scrollTop > 119) {
			this.setState({ navbarStatus: 'relative'});
		} else {
			this.setState({ navbarStatus: 'fixed' });
		}
	}

	toggle = () => {
		this.setState({ navbarTogglerOpen: !this.state.navbarTogglerOpen });
	};

	render() {
		const meta = {
			title: 'Rhodes CRE',
			description: 'Simon rhodes CRE',
			canonical: 'https://a-m-j.co.uk/rhodescre',
			meta: {
				charset: 'utf-8',
				name: {
					keywords: 'simon rhodes, rhodescre'
				}
			}
		};
		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 7000,
		};
		const clientsettings = {
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows: false,
			dots: false,
			pauseOnHover: false,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 4
				}
			}, {
				breakpoint: 520,
				settings: {
					slidesToShow: 3
				}
			}]
		};

		const { open, modalContent } = this.state;
		return (
			<div>
				<DocumentMeta {...meta} />
				<Navbar expand="md"  style={{
					position: this.state.navbarStatus,
					display: this.state.navbarStatus === 'fixed' ? '' : 'none'
				}} className={this.state.navbarStatus === 'fixed' ? 'fixed-top' : ''}>
					<Container>
						<NavbarBrand href="#home">
							<img src={logo} alt="Logo" className="d-inline-block align-top" height="65px" />
						</NavbarBrand>
						<NavbarToggler onClick={this.toggle} />
						<Collapse isOpen={this.state.navbarTogglerOpen} navbar>
							<Nav className={`ml-auto ${this.state.navbarTogglerOpen ? 'show' : 'vertical'}`} navbar>
								<NavItem>
									<NavLink href="#about">About</NavLink>
								</NavItem>
								<NavItem>
									<NavLink href="#services">Services</NavLink>
								</NavItem>
								<NavItem>
									<NavLink href="#contact">Contact</NavLink>
								</NavItem>
								<NavItem>
									<NavLink href="#casestudies">Case Studies</NavLink>
								</NavItem>
							</Nav>
						</Collapse>
					</Container>
				</Navbar>

				<section id="home">
					<div className="section-image"
						style={{
							backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),url(${building})`, backgroundSize: 'cover', filter: 'grayscale(100%)' }}>
					</div>
					<div className="slide-wrapper">
						<div className="slide-content">
							<div className="wrapper right">
								<h1>The Commercial Real Estate Specialists</h1>
								{/*<div className="button-group">
									<span>View more</span> <button type="button"></button>
								</div>*/}
							</div>

						</div>
					</div>
					<div className="section-base black">
						<div className="outer-triangle"></div>

						<div className="content">
							<div className="tag">Our Vision</div>
							To provide structured agency and consultancy advice, by blending unrivalled market knowledge, and experience to deliver a complete commercial property service that always adds value and benefits our clients.
						</div>
					</div>
				</section>
				<div className="section-client">
					<div className="customer-logos">
						<Slider {...clientsettings}>
							<div className="slide"><img src={logo36} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo1} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo3} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo4} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo5} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo6} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo8} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo10} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo11} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo12} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo16} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo33} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo34} alt="Rhodes CRE" /></div>
						</Slider>
					</div>
				</div>
				<section id="about">
					<div className="section-image"
						style={{
							backgroundImage: `linear-gradient(rgba(0,0,0, 0.45), rgba(0,0,0, 0.45)),url(${case4})`, backgroundSize: 'cover', filter: 'grayscale(100%)'
						}}>
					</div>
					<div className="slide-wrapper">
						<div className="slide-content">
							<div className="wrapper right">
								<h1>About Rhodes CRE</h1>
							</div>

						</div>
					</div>

					<div className="section-base green">
						<div className="outer-triangle"></div>

						<Slider {...settings}>
							<div className="content">
								<div className="tag bold">Who we are</div>
								<p>Founded in 2017, Rhodes CRE is an independent award-winning commercial property consultancy. Whilst we work across varying property types, we predominantly specialise in guiding clients through acquisitions in the industrial, logistics and manufacturing sectors.</p>
							</div>
							<div className="content">
								<div className="tag bold">What we do</div>
								We offer most types of commercial property services including strategic agency, development, investment and consultancy advice, spanning the majority of commercial property types. However, it’s our expertise in industrial acquisitions, both in our Yorkshire heartlands and beyond, that really sets us apart.
							</div>
							<div className="content">
								<div className="tag bold">Who we do it for</div>
								<p>We have experience working with numerous clients and representing occupiers, landlords, property companies, corporate organisations, developers, funds, landowners and private individuals. </p>
								<p>Click on our <a href="#casestudies">case studies</a> below to see some of the recent clients that have benefitted from our advice and expertise.</p>
							</div>
							<div className="content">
								<div className="tag bold">Where we do it</div>
								Although a lot of our work is centred in our Yorkshire heartlands and the North East, we operate throughout the UK and beyond. In addition, we have a vast network of industry contacts that we can call on, if we require specific expertise in a less familiar area.
							</div>
							<div className="content">
								<div className="tag bold">How we do it differently</div>
								We create a bespoke, confidential strategy for every project or instruction that we work on, which is crafted around the client’s individual objectives, and we take pride in offering a very personal and director-led service, that is based on many years of industry experience and capability.
							</div>
							<div className="content">
								<div className="tag bold">Impact for clients</div>
								Our client focused approach provides fully integrated and considered strategies, this bespoke service delivers best value while ensuring always the clients objectives are met. Acting as a dedicated commercial advisor we provide high quality and reliable advice enabling our clients to enhance their business property assets.
							</div>
						</Slider>

					</div>
				</section>
				<div className="section-client">
					<div className="customer-logos">
						<Slider {...clientsettings}>
							<div className="slide"><img src={logo20} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo21} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo22} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo23} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo24} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo25} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo26} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo27} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo28} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo30} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo31} alt="Rhodes CRE" /></div>
							<div className="slide"><img src={logo32} alt="Rhodes CRE" /></div>
						</Slider>
					</div>
				</div>
				<section id="services">
					<div className="section-image"
						style={{
							backgroundImage: `linear-gradient(rgba(0,0,0, 0.45), rgba(0,0,0, 0.45)),url(${tor})`, backgroundSize: 'cover', filter: 'grayscale(100%)'
						}}>
					</div>
					<div className="slide-wrapper">
						<div className="slide-content">
							<div className="wrapper right">
								<h1>Services</h1>
							</div>

						</div>
					</div>

					<div className="section-base blue">
						<div className="outer-triangle"></div>

						<Slider {...settings}>
							<div className="content">
								<div className="tag bold">Industrial Acquisition</div>
								Acquiring industrial premises is a fundamental part of what we do and is undoubtedly our specialist area. This ranges from identifying development opportunities and navigating the planning process to the acquisitions of all types and sizes of warehouses, distribution centres, logistics hubs and manufacturing facilities.
								<button onClick={() => this.onOpenModal('industrial')} className="read-more-button">Read more</button>
							</div>
							<div className="content">
								<div className="tag bold">Disposal and Sales</div>
								We are highly experienced at working with clients to create and implement successful, bespoke disposal strategies, covering pricing, timing and marketing, for all types of industrial property throughout Yorkshire and the North East, as well as further afield
								<button onClick={() => this.onOpenModal('disposal')} className="read-more-button">Read more</button>
							</div>
							<div className="content">
								<div className="tag bold">Development and Investment</div>
								We offer innovative, independent and commercial development and investment advice to compliment our agency services to ensure the best results for our clients.
							</div>
							<div className="content">
								<div className="tag bold">Corporate Services</div>
								We have the experience to untangle the vast array of issues that can impact the commercial property industry and provide specialist strategic advice and support to occupiers, landlords and investors throughout the entire life cycle of a property.
								<button onClick={() => this.onOpenModal('corporate')} className="read-more-button">Read more</button>
							</div>
						</Slider>

					</div>
				</section>
				<section id="casestudies">
					<div className="section-image"
						style={{
							backgroundImage: `linear-gradient(rgba(0,0,0, 0.45), rgba(0,0,0, 0.45)),url(${tor})`, backgroundSize: 'cover', filter: 'grayscale(100%)', backgroundPosition: 'bottom'
						}}>
					</div>
					<div className="slide-wrapper">
						<div className="slide-content">
							<div className="wrapper right">
								<h1>Examples of our success</h1>
							</div>

						</div>
					</div>

					<div className="section-base grey">
						<div className="outer-triangle"></div>
						<Slider {...settings}>
							<div className="content">
								<div className="tag bold">Tremco Illbruck</div>
								Leasehold acquisition of 95,000 sq ft distribution hub at Leicester Commercial Park
								<button onClick={() => this.onOpenModal('leicester')} className="read-more-button">Read more</button>
							</div>
							<div className="content">
								<div className="tag bold">Aston Barclay</div>
								Leasehold acquisition of new state of the art vehicle auction centre, 85,000 sq ft on 16 acres at Photon Park, Wakefield
								<button onClick={() => this.onOpenModal('astonbarclay')} className="read-more-button">Read more</button>
							</div>
							<div className="content">
								<div className="tag bold">Asda</div>
								Leasehold acquisition of a new 315,000 sq ft distribution facility at Redhouse, Doncaster
							</div>
							<div className="content">
								<div className="tag bold">Goodyear Dunlop</div>
								Freehold disposal of a 45 acre brownfield development site in Newcastle.
							</div>
							<div className="content">
								<div className="tag bold">Standard Life Investors</div>
								Leasehold disposal of over 930,000 sq ft of distribution warehouse accomodation at Firstpoint, Doncaster.
							</div>
							<div className="content">
								<div className="tag bold">Kimberley Clark</div>
								Freehold disposal of one of the largest manufacturing facilities in the North of England comprising 750,000 sq ft on 178 acres.
							</div>
							<div className="content">
								<div className="tag bold">TOR Coatings</div>
								Leasehold acquisition of a new development comprising a 135,000 sq ft distribution facility, Follingsby Park, Newcastle.
								<button onClick={() => this.onOpenModal('torcoatings')} className="read-more-button">Read more</button>
							</div>
							<div className="content">
								<div className="tag bold">Thirsk Investments</div>
								Freehold disposal of the former Austin Reed facility in Thirsk providing a 10 acre development site.
							</div>
							<div className="content">
								<div className="tag bold">Yodel</div>
								Freehold acquisition of 60,000 sq ft warehouse facility plus disposal of 4 acres development plot at Access 63, Selby
								<button onClick={() => this.onOpenModal('yodel')} className="read-more-button">Read more</button>
							</div>
						</Slider>

					</div>
				</section>
				<div className="section-footer black border-b-white" id="contact">

					<div className="content large">
						<Row>
							<Col lg={{ size: 6, offset: 3 }}>
								<h3 className="text-center" style={{marginBottom: '20px'}}>Simon Rhodes BSc (Hons) MRICS - Managing Director</h3>
								<p className="text-center" style={{ marginBottom: '30px', fontSize: '14px' }}>With over 25 years’ experience in the commercial property industry, Simon is an RICS Chartered Surveyor who has led industrial and logistics teams at well known Chartered Surveying practices, representing occupiers, landowners, developers, investors and corporate organisations.</p>
							</Col>
						</Row>
						<div className="title-center">Make an enquiry</div>
						<h2>What are you looking for?</h2>
						<Row>
							<Col lg={{size: 6, offset: 3}}>
								<div id="mc_embed_signup">
									<form action="https://rhodescre.us18.list-manage.com/subscribe/post?u=f1f9a645e6e8840b951b25651&amp;id=e0decfb79c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" noValidate>
										<div id="mc_embed_signup_scroll">
											<FormGroup>
												<Label for="mce-EMAIL" className="form-label">Email Address</Label>
												<Input type="email" value={this.state.email} name="EMAIL" className="form-label" id="mce-EMAIL" onChange={evt => this.handleEmailChange(evt)}/>
											</FormGroup>
											<FormGroup>
												<Label for="mce-FNAME" className="form-label">Full Name</Label>
												<Input type="text" value={this.state.fullName} name="FNAME" id="mce-FNAME" onChange={evt => this.handleFullNameChange(evt)}/>
											</FormGroup>
											<FormGroup>
												<Label for="mce-PHONE" className="form-label">Phone Number </Label>
												<Input type="number" name="PHONE" value={this.state.phone} id="mce-PHONE" onChange={evt => this.handlePhoneChange(evt)}/>
											</FormGroup>
											<FormGroup>
												<Label for="mce-MMERGE2" className="form-label">Message </Label>
												<Input type="textarea" value={this.state.message} name="MMERGE2" placeholder="Enter your message" id="mce-MMERGE2" onChange={evt => this.handleMessageChange(evt)}/>
											</FormGroup>
											<div id="mce-responses">
												<div id="mce-error-response" style={{display:'none'}}></div>
												<div id="mce-success-response" style={{ display: 'none' }}></div>
											</div>
											<div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
												<Input type="text" name="b_f1f9a645e6e8840b951b25651_e0decfb79c" tabIndex="-1" value="" />
											</div>
											<div><Input type="submit" value="Submit" name="subscribe" id="mc-embedded-subscribe" className="btn btn-primary" /></div>
										</div>
									</form>
								</div>
							</Col>
						</Row>
					</div>
				</div>
				<div className="section-footer black">
					<div className="content medium">
						<div className="container">
							<div className="row">
								<div className="col-xs-12 col-md-6 ">
									<div className="content-flex">
										<div>
											<img src={logoSmall} width="50px" alt="Logo"/>
										</div>
										<div>
											<p className='regulated-by'>Regulated by</p>
											<img src={rics} width="200px" alt="Logo" />
										</div>

										<div className="copy">2018 Rhodes CRE Limited<br />
											<span className="small">Registered in England and Wales – Company Number - 10906164</span><br />
											<span className="small">Registered address – 7 Princes Square, Harrogate, North Yorkshire, HG1 1ND</span>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-6 order-first order-md-2">
									<div className="row">
										<div className="col-6">
											<ul className="o-list-block o-footer--list">
												<li className="o-list__item title">
													Head Office
												</li>
												<li className="o-list__item">
													2018 Rhodes CRE Limited
												</li>
												<li className="o-list__item">
													First Floor, 5 Sheepscar Court
												</li>
												<li className="o-list__item">
													Leeds
												</li>
												<li className="o-list__item">
													West Yorkshire
												</li>
												<li className="o-list__item">
													LS7 2BB
												</li>
											</ul>
										</div>
										<div className="col-6">

										</div>
										<div className="col-6 u-mar-t-large">
											<ul className="o-list-block o-footer--list">
												<li className="o-list__item title">
													Get in touch
												</li>
												<li className="o-list__item">
													<a className="link green" href="tel:07795010203">m: 00 44 7795 010 203</a>
												</li>
												<li className="o-list__item">
													<a className="link green" href="tel:00441133502310">t: 00 44 113 350 2310</a>
												</li>
												<li className="o-list__item">
													<a className="link green" href="mailto:enquiries@rhodescre.com">enquiries@rhodescre.com</a>
												</li>
											</ul>
										</div>
										<div className="col-6">
											<ul className="o-list-block o-footer--list">
												<li className="o-list__item">
													<a className="link grey" href="#about">About</a>
												</li>
												<li className="o-list__item">
													<a className="link grey" href="#services">Services</a>
												</li>
												<li className="o-list__item">
													<a className="link grey" href="#contact">Contact</a>
												</li>
												<li className="o-list__item">
													<a className="link grey" href="#casestudies">Case Studies</a>
												</li>
											</ul>
										</div>

									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
				<Modal open={open} onClose={this.onCloseModal} center>
					<h2>{modalContent && caseStudies[modalContent].heading}</h2>
					{modalContent && caseStudies[modalContent].imgSrc && <img src={caseStudies[modalContent].imgSrc} alt={caseStudies[modalContent].heading}/>}
					{modalContent && <div dangerouslySetInnerHTML={{ __html: caseStudies[modalContent].bodyText }} />}
        </Modal>
				{/*<ScrollButton scrollStepInPx="50" delayInMs="16.66" />*/}

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/scripts/pages/RhodesCRE.js